import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  path: string;
}

const SEO = ({ title, description, path }: SEOProps) => (
  <Helmet>
    <title>{title} | Medvedica SKI PRO stats</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`https://ski-stats.onrender.com${path}`} />
  </Helmet>
);

export default SEO; 